<template>
  <b-modal v-model="isShow" size="md" :title="type === 0 ? 'Yêu cầu điều chỉnh chính sách' : 'Xác nhận chính sách'" v-b-modal.modal-scrollable>
    <h6>Ghi chú</h6>
    <b-form-textarea
      v-model="note"
      placeholder="Ghi chú thông tin"
      rows="3"
      max-rows="6"
    />
    <template #modal-footer="{ hide }">
      <b-button variant="outline-danger" @click="hide()">
        Huỷ bỏ
      </b-button>
      <b-button variant="outline-primary" @click="submit">
        Xác nhận
      </b-button>
    </template>
    <VueLoadingOverlay :active.sync="isLoading">
    </VueLoadingOverlay>
  </b-modal>
</template>

<script>
  import { DeviceService } from '@/services/device.service'

  export default {
    name: 'PopupRentConfirm',
    props: {
      id: {
        type: String,
        default: '',
      },
    },
    data () {
      return {
        isShow: false,
        isLoading: false,
        note: '',
        type: 0 // 0: request update | 1: configm policy
      }
    },

    methods: {
      async submit() {
        try {
          this.isLoading = true;
          const res = this.type === 0 ? await DeviceService.requestUpdate({
            id: this.id,
            note: this.note
          }) : await DeviceService.confirmPolicy({
            id: this.id,
            note: this.note
          })
          if (res.code === 1000) {
            this.$emit('success')
            this.isShow = false;
          } else {
            this.showFailMx(res.message)
          }
        } catch (e) {
          this.showFailMx(e.message)
        } finally {
          this.isLoading = false;
        }
      },

      show(type) {
        this.isShow = true;
        this.note = '';
        this.type = type;
      }
    }
  }
</script>

<style scoped>

</style>
